import { useState } from "react";
import "./Header.css";
import "../components/Modal.css";
import HelpOutline from "@material-ui/icons/HelpOutline";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import IconButton from "@material-ui/core/IconButton";

import { useSelector, useDispatch } from "react-redux";
import { dataActions } from "../store/data-slice";
import { screenActions } from "../store/screens-slice";
import { stepperActions } from "../store/stepper-slice";
import { toggleActions } from "../store/toggle-slice";

import PopPop from "react-poppop";

import { useTranslation } from "react-i18next";

/*
 HEADER:
      - contains title (Licencia de navegación)
      - responsable for controlling the modal (popup)
*/

const Header = () => {
  const [t] = useTranslation("global");

  const dispatch = useDispatch();

  const screen = useSelector((state) => state.screens.mainScreen);

  const [show, setshow] = useState(false);

  const toggleShow = (show) => {
    setshow(show);
  };

  const renderScreen = () => {
    if (screen === "teoria") {
      dispatch(screenActions.setMainScreen("practicas"));
      dispatch(stepperActions.setActiveStep(0));

      dispatch(dataActions.elementoSeleccionadoEnTeoria(""));
      dispatch(screenActions.setScrollDivTeoria(""));
      dispatch(dataActions.setFechaDespues(-1));
      dispatch(toggleActions.disableClass(false));
      dispatch(toggleActions.disableElements(false));
      dispatch(toggleActions.disableFechaDespues(false));
    } else if (screen === "extras") {
      dispatch(dataActions.applyExtras([]));
      dispatch(dataActions.setResetExtrasState());
      dispatch(stepperActions.handleBackStep());
      dispatch(screenActions.setMainScreen("teoria"));
      dispatch(stepperActions.setActiveStep(1));
    } else if (screen === "resumen") {
      dispatch(screenActions.setMainScreen("extras"));
      dispatch(stepperActions.setActiveStep(2));
    }
  };

  return (
    <>
      <div className="header__top">
        <div className="header__title">
          {screen !== "practicas" && (
            <div className="header__backButton" onClick={renderScreen}>
              <ArrowBackIosIcon />
            </div>
          )}

          <div>
            <h3>
              <span>{t("HEADER.title.shortcut")}</span> -{" "}
              {t("HEADER.title.full")}
            </h3>
          </div>
        </div>

        <PopPop
          position="centerCenter"
          open={show}
          closeBtn={true}
          closeOnEsc={true}
          onClose={() => toggleShow(false)}
          closeOnOverlay={true}
          contentStyle={{
            backgroundColor: "white",
            overflow: "hidden",
          }}
        >
          <div className="modal__smallContainer">
            <h3>
              <span>1 </span>
              {t("HEADER.modal.first.title")}
            </h3>
            <p>{t("HEADER.modal.first.paragraph")}</p>
            <h3>
              <span>2 </span>
              {t("HEADER.modal.second.title")}
            </h3>
            <p>{t("HEADER.modal.second.paragraph")}</p>
            <h3>
              <span>3 </span>
              {t("HEADER.modal.third.title")}
            </h3>
            <p>
              <p>{t("HEADER.modal.third.paragraph1")}</p>
            </p>
            <p>
              <p>{t("HEADER.modal.third.paragraph2")}</p>
            </p>
          </div>
        </PopPop>

        <div className="header__iconContainer">
          <IconButton
            onClick={() => {
              toggleShow(true);
            }}
          >
            <HelpOutline />
          </IconButton>
        </div>
      </div>
    </>
  );
};

export default Header;
